import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DisplayUrl } from "src/app/models/common/DisplayUrl";
import { DeferServiceAccountRequest } from "src/app/models/servicePrivilegeAccounts/DeferServiceAccountRequest";
import { ChevronApplicationService } from "src/app/services/application/ChevronApplication.service";
import { AppConfigService } from "src/app/services/common/AppConfigService";

@Component({
    selector: 'request-details-service-account-deferment',
    templateUrl: './request-details-service-account-deferment.component.html'
})

export class RequestDetailsServiceAccountDeferment implements OnInit {

    @Input() requestData: DeferServiceAccountRequest;

    @Output() doneLoading = new EventEmitter<boolean>();
    displayObject: any;

    constructor(private chevronAppService: ChevronApplicationService, private configService: AppConfigService) { }
    cmdbServiceIdUrlReplaceToken: string = this.configService.getConfig().cmdbServiceIdUrlReplaceToken;
    cmdbServiceIdUrl: string = this.configService.getConfig().cmdbServiceIdUrl;
    ngOnInit() {
        this.search();
    }

    async search() {
        if (this.requestData.serviceAccount.applicationId) {
            let apiCall = this.chevronAppService.SearchApplication(this.requestData.serviceAccount.applicationId!);
            apiCall.subscribe({
                next: (r) => {
                    if (r.data.length > 0) {
                        const serviceIdDisplayUrl = this.requestData.serviceAccount.applicationId == undefined ? '' : new DisplayUrl(this.requestData.serviceAccount.applicationId, this.cmdbServiceIdUrl.replace(this.cmdbServiceIdUrlReplaceToken, this.requestData.serviceAccount.applicationId));
                        this.displayObject = {
                            userPrincipalName: this.requestData.serviceAccount.emailId,
                            serviceId: serviceIdDisplayUrl,
                            applicationName: r.data[0].displayName,
                            accountId: this.requestData.serviceAccount.userId,
                            justification: this.requestData.justification
                        };
                    }
                },
                error: (e) => {
                    console.error(e);
                },
                complete: () => {
                    this.doneLoading.emit(true);
                }
            });
        }
    }
}